module.exports = __webpack_public_path__ + "img/spacex1.87a8df3f.png";